import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import config from "../../config";

const baseUrl = config.baseURL;
const PRIMARY_COLOR = "#2E4053";
const ACCENT_COLOR = "#8B4513";

const ShopForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const getShopFromSubdomain = () => {
    const host = window.location.hostname;
    const parts = host.split(".");
    if (parts.length >= 3) return parts[0];
    return null;
  };

  const shopSubdomain = getShopFromSubdomain();

  const handleReset = async () => {
    if (!email) {
      toast.error("Please enter your email.");
      return;
    }

    if (!shopSubdomain) {
      toast.error("Invalid shop domain.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `${baseUrl}/api/shop/customer/request-reset?shop=${shopSubdomain}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      const data = await response.json();

      if (data.messageId === 0) {
        toast.success("Reset link sent to your email.");
      } else {
        toast.error(data.message || "Failed to send reset link.");
      }
    } catch (error) {
      console.error("Reset error:", error);
      toast.error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#F4F6F8",
        p: 2,
      }}
    >
      <Card sx={{ maxWidth: 400, width: "100%", borderRadius: 3, p: 2 }}>
        <CardContent>
          <Typography
            variant="h5"
            sx={{
              fontWeight: "600",
              mb: 3,
              color: PRIMARY_COLOR,
              textAlign: "center",
            }}
          >
            Reset Your Password
          </Typography>

          <Typography
            sx={{ mb: 2, fontSize: 14, color: "#666", textAlign: "center" }}
          >
            Enter your email and we will send you a reset link.
          </Typography>

          <TextField
            fullWidth
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{
              mb: 3,
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                { borderColor: PRIMARY_COLOR },
              "& .MuiInputLabel-root.Mui-focused": { color: PRIMARY_COLOR },
            }}
          />

          <Button
            fullWidth
            variant="contained"
            sx={{
              backgroundColor: PRIMARY_COLOR,
              color: "#fff",
              py: 1.5,
              fontWeight: 600,
              "&:hover": { backgroundColor: ACCENT_COLOR },
            }}
            onClick={handleReset}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} sx={{ color: "#fff" }} />
            ) : (
              "Send Reset Link"
            )}
          </Button>

          <Typography
            sx={{
              mt: 2,
              textAlign: "center",
              fontSize: 14,
              cursor: "pointer",
              color: PRIMARY_COLOR,
            }}
            onClick={() => navigate("/shop/customerlogin")}
          >
            Back to Login
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ShopForgotPassword;
